import { useSelector } from '../../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../../app.store';

const lassoStateSelector = (state: AppState) => state.frontendState.mapTools.lasso;
export const useLassoStateSelector = () => useSelector(lassoStateSelector);

const lassoIsActiveSelector = (state: AppState) => state.frontendState.mapTools.lasso.isActive;
export const useLassoIsActiveSelector = () => useSelector(lassoIsActiveSelector);
